import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import './App.css';
import Dashboard from "./Dashboard";
import Login from "./Login";
import Password from "./Password";
import Runner from "./Runner";
import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";

function RequireAuth({ children, redirectTo }) {
  let isAuthenticated = !!sessionStorage.getItem('token');
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

function App() {
  const location = useLocation()
  const toast = useToast()


  useEffect(() => {
    const duration = process.env.REACT_APP_TIMEOUT || 300
    console.log('app would timeout in', duration, 'seconds')
    let timeout = null;
    const restartAutoReset = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        toast({
          title: 'You have been signed out due to inactivity',
          position: 'top-right',
          isClosable: true,
          status: 'error'
        })
        window.location.href = '/login'
      }, 1000 * duration);
    };
    const onMouseMove = () => {
      restartAutoReset();
    };
    // Whitelist certain pages
    for (const path of ['/login']) {
      if (path === location.pathname) {
        return
      }
    }
    restartAutoReset();

    window.addEventListener('mousemove', onMouseMove);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
        window.removeEventListener('mousemove', onMouseMove);
      }
    };
  }, [location]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/password" element={<Password />} />
      <Route path="/dashboard" element={
        <RequireAuth redirectTo="/login">
          <Dashboard />
        </RequireAuth>
      } />
      <Route path="/" element={
        <RequireAuth redirectTo="/login">
          <Dashboard />
        </RequireAuth>
      } />
      <Route path="/runner" element={
        <RequireAuth redirectTo="/login">
          <Runner />
        </RequireAuth>
      } />
    </Routes>
  );
}

export default App;
